import React from 'react';
import Fader from 'react-fader';
import { Route, SwitchProps } from 'react-router-dom';
import Switch from 'react-router-transition-switch';

import useIsMobile from 'hooks/useIsMobile';

import AllTrips from './screens/AllTrips';
import FaqQuestion from './screens/FaqQuestion';
import FaqSection from './screens/FaqSection';
import Home from './screens/Home';
import Mail from './screens/Mail';
import TripSupport from './screens/TripSupport';

const CustomerSupport = () => {
  const isMobile = useIsMobile();

  return (
    <Switch
      render={({ children }: SwitchProps) => (
        <Fader style={isMobile ? { height: '100%' } : {}} viewStyle={isMobile ? { height: '100%' } : {}}>
          {children}
        </Fader>
      )}
    >
      <Route exact path="/customerSupport" component={Home} />
      <Route exact path="/customerSupport/faq/:section" component={FaqSection} />
      <Route exact path="/customerSupport/faq/:section/:question" component={FaqQuestion} />

      <Route exact path="/customerSupport/mail" component={Mail} />

      <Route exact path="/customerSupport/allTrips" component={AllTrips} />
      <Route exact path="/customerSupport/trip/:id" component={TripSupport} />
    </Switch>
  );
};

export default CustomerSupport;
